import React from "react";
import MTooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import {
  BarChart,
  Cell,
  Bar,
  XAxis,
  Tooltip,
} from "recharts";

import IconButton from "@material-ui/core/IconButton";

const CustomTooltip = () => ({
  render() {
    const { active } = this.props;

    if (active) {
      const { payload, label } = this.props;

      return (
        <div
          className="custom-tooltip"
          style={{
            backgroundColor: "rgba(100,100,100,0.8)",
            color: "white",
            padding: "3px",
            borderRadius: "5px",
          }}
        >
          <p className="label">
            {`${label} : ${
              payload &&
              payload[0] &&
              payload[0].value.toLocaleString("pl-PL", {
                maximumFractionDigits: 0,
              })
            }`}
          </p>
        </div>
      );
    }

    return null;
  },
});

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "white",
    color: "black",
    maxWidth: 600,
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: "100",
    boxShadow: "10px 10px 24px -1px rgba(70,70,70,0.75)",
  },
}))(MTooltip);

const posorneg = (type, value) => {
  let color = "black";

  let positive = value < 0 ? false : true;

  if (type === "cost") positive = !positive;
  if (!positive) color = "#FE8E3C";
  if (type === "text") color = "black";

  return color;
};

const CostByStagesTable = (props) => {
  const maximumFractionDigits = props.maximumFractionDigits || 0;
  const minimumFractionDigits = props.minimumFractionDigits || 0;

  const customMarginRight = props.marginRight || "0px";
  const tinyChartWidth = props.tinyChartWidth || 150;

  /*
   * Opcjonalnie:
   *
   * columnWidths={["250px", "auto", 60, "170px"]}
   *
   * rowHeight={40}
   *
   * columnWidths dotyczy wyłącznie props.columns.
   * Nie obejmuje pierwszej technicznej kolumny
   * zawierającej przycisk rozwijania.
   */
  const columnWidths = props.columnWidths || [];
  const rowHeight = props.rowHeight;

  /*
   * Przy table-layout: fixed szerokość kolumn jest
   * kontrolowana przez colgroup.
   *
   * "auto" oznacza tutaj: kolumna otrzyma część
   * pozostałego miejsca.
   */
  const getColumnWidth = (columnIndex) => {
    const width = columnWidths[columnIndex];

    if (
      width === undefined ||
      width === null ||
      width === "auto"
    ) {
      return undefined;
    }

    return width;
  };

  const getRowHeightStyle = () => {
    if (
      rowHeight === undefined ||
      rowHeight === null ||
      rowHeight === "auto"
    ) {
      return {};
    }

    return {
      height: rowHeight,
    };
  };

  const CostByStagesMain = (props) => {
    const { dimUnexpanded } = props;

    const [openNodes, setOpenNodes] = React.useState([]);

    const handleOpenNodes = (id) => {
      const temp = [...openNodes];
      const idx = temp.indexOf(id);

      if (idx === -1) {
        if (dimUnexpanded === "true") temp.length = 0;
        temp.push(id);
      } else {
        temp.splice(idx, 1);
      }

      setOpenNodes(temp);
    };

    function RowKB(props) {
      function Row(props) {
        const { row } = props;

        return (
          <React.Fragment>
            {row && (
              <TableRow
                key={props.rowkey}
                hover
                className="animate__animated animate__fadeIn"
                style={{
                  ...getRowHeightStyle(),
                }}
              >
                {/* techniczna kolumna ze strzałką */}
                <TableCell
                  component="th"
                  scope="row"
                  style={{
                    paddingLeft: 30 + 15 * props.lvl,
                    borderBottom: "0px solid",
                    ...getRowHeightStyle(),
                  }}
                >
                  {row.children && row.children.length > 0 && (
                    <IconButton
                      aria-label="expand row"
                      size="small"
                      style={{ color: "lightgray" }}
                      onClick={() =>
                        handleOpenNodes(props.rowkey)
                      }
                    >
                      {openNodes.includes(props.rowkey) ? (
                        <KeyboardArrowDownIcon />
                      ) : (
                        <KeyboardArrowRightIcon />
                      )}
                    </IconButton>
                  )}
                </TableCell>

                {props.columns.map(
                  (column, columnIndex) => (
                    <TableCell
                      key={
                        column.value ||
                        `column-${columnIndex}`
                      }
                      component="th"
                      scope="row"
                      align={column.align}
                      style={{
                        ...getRowHeightStyle(),
                      }}
                    >
                      {column.type === "graph" ? (
                        <div>
                          <svg
                            className="rankBar"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox={`${row.graphMin} 0 200 5`}
                            preserveAspectRatio="none"
                            version="1.1"
                          >
                            <rect
                              x={Math.min(
                                0,
                                row[column.value]
                              )}
                              width={Math.abs(
                                row[column.value]
                              )}
                              height="5"
                              stroke="none"
                              strokeWidth="1"
                              fill={
                                row[column.value] > 0
                                  ? "#0B6471"
                                  : "orange"
                              }
                            />
                          </svg>
                        </div>
                      ) : column.type === "tinychart" ? (
                        <BarChart
                          style={{
                            padding: "0px",
                            margin: "0px",
                          }}
                          width={tinyChartWidth}
                          height={30}
                          data={row[column.value]}
                          isAnimationActive={false}
                        >
                          <Tooltip
                            content={<CustomTooltip />}
                          />

                          <XAxis
                            dataKey="m"
                            hide={true}
                          />

                          <Bar
                            isAnimationActive={false}
                            dataKey="cost"
                            fill="#0B6471"
                            barSize={
                              tinyChartWidth /
                              (1.5 * 12)
                            }
                          >
                            {row[column.value] &&
                              row[column.value].map(
                                (entry, index) => (
                                  <Cell
                                    key={index}
                                    cursor="pointer"
                                    fill={
                                      entry.cost < 0
                                        ? "#FE8E3C"
                                        : "#cee0e3"
                                    }
                                  />
                                )
                              )}
                          </Bar>
                        </BarChart>
                      ) : (
                        <Typography
                          variant="body2"
                          style={{
                            paddingLeft: 0,
                            color: posorneg(
                              column.type,
                              row[column.value]
                            ),
                            fontSize:
                              column.fontSize ||
                              undefined,
                          }}
                        >
                          {row[column.value] &&
                          row[column.value] != 0
                            ? row[
                                column.value
                              ].toLocaleString(
                                "pl-PL",
                                {
                                  maximumFractionDigits:
                                    maximumFractionDigits,
                                  minimumFractionDigits:
                                    minimumFractionDigits,
                                }
                              )
                            : ""}
                        </Typography>
                      )}
                    </TableCell>
                  )
                )}
              </TableRow>
            )}

            {openNodes.includes(props.rowkey) &&
              row.children &&
              row.children.map((child, uid) => (
                <Row
                  key={`${props.rowkey}_${uid}`}
                  rowkey={`${props.rowkey}_${uid}`}
                  row={child}
                  lvl={props.lvl + 1}
                  columns={props.columns}
                />
              ))}
          </React.Fragment>
        );
      }

      return (
        <React.Fragment>
          <TableRow
            key={props.rowkey}
            hover={true}
            style={{
              backgroundColor:
                openNodes.includes(props.rowkey)
                  ? "#f5f9f9"
                  : undefined,
              borderRadius: "5px",
              outline: "none",
              opacity:
                openNodes.length === 0
                  ? 1
                  : openNodes.includes(
                      props.rowkey
                    )
                  ? 1
                  : 0.2,
              ...getRowHeightStyle(),
            }}
          >
            {/* techniczna kolumna ze strzałką */}
            <TableCell
              component="th"
              scope="row"
              style={{
                borderBottom: "0px solid",
                borderRadius:
                  "5px 0px 0px 5px",
                ...getRowHeightStyle(),
              }}
            >
              {props.data.children &&
                props.data.children.length >
                  0 && (
                  <IconButton
                    aria-label="expand row"
                    size="small"
                    onClick={() =>
                      handleOpenNodes(
                        props.rowkey
                      )
                    }
                  >
                    {openNodes.includes(
                      props.rowkey
                    ) ? (
                      <KeyboardArrowDownIcon />
                    ) : (
                      <KeyboardArrowRightIcon />
                    )}
                  </IconButton>
                )}
            </TableCell>

            {props.columns.map(
              (column, columnIndex) => (
                <TableCell
                  key={
                    column.value ||
                    `column-${columnIndex}`
                  }
                  align={column.align}
                  style={{
                    fontWeight:
                      openNodes.includes(
                        props.rowkey
                      ) ||
                      props.data.opk_id ===
                        "Ogółem"
                        ? 500
                        : [
                            "income",
                            "result",
                            "margin",
                          ].includes(
                            props.data?.type
                          )
                        ? 1000
                        : 100,

                    color: posorneg(
                      column.type,
                      props.data[
                        column.value
                      ]
                    ),

                    ...getRowHeightStyle(),
                  }}
                >
                  {column.type === "graph" ? (
                    <div>
                      <svg
                        className="rankBar"
                        style={{
                          opacity:
                            openNodes.length ===
                            0
                              ? 1
                              : 0,
                        }}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox={`${props.data.graphMin} 0 200 5`}
                        preserveAspectRatio="none"
                        version="1.1"
                      >
                        <rect
                          x={Math.min(
                            0,
                            props.data[
                              column.value
                            ]
                          )}
                          width={Math.abs(
                            props.data[
                              column.value
                            ]
                          )}
                          height="5"
                          stroke="none"
                          strokeWidth="1"
                          fill={
                            props.data[
                              column.value
                            ] > 0
                              ? "#0B6471"
                              : "orange"
                          }
                        />
                      </svg>
                    </div>
                  ) : column.type ===
                    "tinychart" ? (
                    <BarChart
                      style={{
                        padding: "0px",
                        margin: "0px",
                      }}
                      width={tinyChartWidth}
                      height={30}
                      data={
                        props.data[
                          column.value
                        ]
                      }
                      isAnimationActive={false}
                    >
                      <Tooltip
                        content={
                          <CustomTooltip />
                        }
                      />

                      <XAxis
                        dataKey="m"
                        hide={true}
                      />

                      <Bar
                        isAnimationActive={false}
                        dataKey="cost"
                        fill="#0B6471"
                        barSize={
                          tinyChartWidth /
                          (1.5 * 12)
                        }
                      >
                        {props.data[
                          column.value
                        ] &&
                          props.data[
                            column.value
                          ].map(
                            (
                              entry,
                              index
                            ) => (
                              <Cell
                                key={index}
                                cursor="pointer"
                                fill={
                                  entry.cost <
                                  0
                                    ? "#FE8E3C"
                                    : "#cee0e3"
                                }
                              />
                            )
                          )}
                      </Bar>
                    </BarChart>
                  ) : column.type ===
                    "mixed" ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection:
                          "column",
                        borderRadius: "3px",
                        border:
                          "1px solid #ececec",
                        backgroundColor:
                          "#f9f9f9",
                        padding: "5px",
                      }}
                    >
                      {props.data[
                        column.value
                      ] &&
                      props.data[
                        column.value
                      ] != 0
                        ? props.data[
                            column.value
                          ].toLocaleString(
                            "pl-PL",
                            {
                              maximumFractionDigits:
                                maximumFractionDigits,
                              minimumFractionDigits:
                                minimumFractionDigits,
                            }
                          )
                        : "-"}

                      <div>
                        <BarChart
                          style={{
                            padding: "0px",
                            margin: "0px",
                          }}
                          width={100}
                          height={30}
                          data={
                            props.data[
                              column
                                .chartValue
                            ]
                          }
                          isAnimationActive={
                            false
                          }
                        >
                          <Tooltip
                            content={
                              <CustomTooltip />
                            }
                          />

                          <XAxis
                            dataKey="m"
                            hide={true}
                          />

                          <Bar
                            isAnimationActive={
                              false
                            }
                            dataKey="cost"
                            fill="#0B6471"
                            barSize={
                              100 /
                              (1.5 * 12)
                            }
                          >
                            {props.data[
                              column
                                .chartValue
                            ] &&
                              props.data[
                                column
                                  .chartValue
                              ].map(
                                (
                                  entry,
                                  index
                                ) => (
                                  <Cell
                                    key={
                                      index
                                    }
                                    cursor="pointer"
                                    fill={
                                      entry.cost <
                                      0
                                        ? "#FE8E3C"
                                        : "#cee0e3"
                                    }
                                  />
                                )
                              )}
                          </Bar>
                        </BarChart>
                      </div>
                    </div>
                  ) : props.data[
                      column.value
                    ] &&
                    props.data[
                      column.value
                    ] != 0 ? (
                    props.data[
                      column.value
                    ].toLocaleString(
                      "pl-PL",
                      {
                        maximumFractionDigits:
                          maximumFractionDigits,
                        minimumFractionDigits:
                          minimumFractionDigits,
                      }
                    )
                  ) : (
                    ""
                  )}
                </TableCell>
              )
            )}
          </TableRow>

          {openNodes.includes(
            props.rowkey
          ) &&
            props.data.children &&
            props.data.children.map(
              (row, uid) => (
                <Row
                  key={`${props.rowkey}_${uid}`}
                  rowkey={`${props.rowkey}_${uid}`}
                  row={row}
                  columns={
                    props.columns
                  }
                  lvl={0}
                />
              )
            )}
        </React.Fragment>
      );
    }

    /*
     * Jeżeli podano columnWidths, przełączamy
     * tabelę na table-layout: fixed.
     *
     * Bez columnWidths zachowuje się jak wcześniej.
     */
    const useFixedLayout =
      columnWidths.length > 0;

    return (
      <Paper
        style={{
          minWidth: "410px",
          width: "100%",
          padding: "5px",
          marginBottom: "10px",
          marginRight:
            customMarginRight,
        }}
      >
        <Typography
          style={{
            color: "#0b6471",
            fontSize: "16px",
            fontWeight: "100",
            borderBottom: "0px solid",
            paddingLeft: "10px",
            paddingTop: "5px",
          }}
        >
          {props.title ||
            "ETAPY ALOKACJI"}
        </Typography>

        <TableContainer>
          <Table
            size="small"
            aria-label="simple table"
            style={{
              width: "100%",
              tableLayout:
                useFixedLayout
                  ? "fixed"
                  : "auto",
            }}
          >
            {/*
             * COLGROUP steruje szerokościami kolumn.
             *
             * Pierwszy <col> to techniczna kolumna
             * ze strzałką rozwijania.
             *
             * Kolejne odpowiadają dokładnie
             * props.columns.
             */}
            {useFixedLayout && (
              <colgroup>
                <col
                  style={{
                    width: "48px",
                  }}
                />

                {props.columns.map(
                  (
                    column,
                    columnIndex
                  ) => {
                    const width =
                      getColumnWidth(
                        columnIndex
                      );

                    return (
                      <col
                        key={
                          column.value ||
                          columnIndex
                        }
                        style={
                          width !==
                          undefined
                            ? {
                                width:
                                  width,
                              }
                            : {}
                        }
                      />
                    );
                  }
                )}
              </colgroup>
            )}

            <TableHead
              style={{
                border: "none",
              }}
            >
              <TableRow
                style={{
                  ...getRowHeightStyle(),
                }}
              >
                <TableCell
                  style={{
                    borderBottom:
                      "0px solid",
                    ...getRowHeightStyle(),
                  }}
                />

                {props.columns.map(
                  (
                    column,
                    columnIndex
                  ) => (
                    <TableCell
                      key={
                        column.value ||
                        columnIndex
                      }
                      style={{
                        color:
                          "#0b6471",
                        fontSize:
                          "16px",
                        fontWeight:
                          "100",
                        borderBottom:
                          column.underline,
                        ...getRowHeightStyle(),
                      }}
                      align={
                        column.align
                      }
                    >
                      {column.name}
                    </TableCell>
                  )
                )}
              </TableRow>
            </TableHead>

            <TableBody>
              {props.data.map(
                (account, uid) => (
                  <RowKB
                    key={uid}
                    data={account}
                    rowkey={uid}
                    columns={
                      props.columns
                    }
                    dimUnexpanded={
                      dimUnexpanded
                    }
                  />
                )
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    );
  };

  return (
    <CostByStagesMain
      data={props.data}
      title={props.title}
      columns={props.columns}
      dimUnexpanded={
        props.dimUnexpanded
      }
    />
  );
};

export default CostByStagesTable;